import React from 'react';
import Login from './index';


const ClassLinkLogin = () => {
    return <Login></Login>
}

export default ClassLinkLogin;